import { Container, ContainerMessage, Content, Paragraph } from "./styles";
import { useNavigate } from "react-router-dom";

const ModalCookies = () => {
  const navigate = useNavigate();
  return (
    <Container>
      <Content>
        <ContainerMessage>
          <div
            style={{
              display: "flex",
              gap: 1,
              alignItems: "center",
            }}
          >
            <Paragraph>
              A Suprema Charque utiliza cookies para facilitar o uso do site,
              melhorar o seu desempenho e segurança, personalizar
              <br /> o conteúdo proposto. Para saber mais sobre como tratamos
              seus dados, acesse a nossa 
              <span
                style={{
                  color: "#007BFF",
                  cursor: "pointer",
                  textDecoration: "underline",
                }}
                onClick={() => navigate("/privacy-policies")}
              >
                Política de Privacidade.
              </span>
            </Paragraph>
          </div>

          {/* BOTOES */}
          <div
            style={{
              display: "flex",
              gap: 10,
              alignItems: "center",
            }}
          >
            <button
              style={{
                backgroundColor: "#FF0000",
                padding: "8px 16px",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
                boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)",
                color: "white",
                fontSize: "15px",
              }}
              onClick={() => {
                localStorage.setItem("cookies-accepted", "true");
                window.location.reload();
              }}
            >
              ACEITAR
            </button>
            <button
              style={{
                backgroundColor: "#FFFFFF",
                padding: "8px 16px",
                border: "none",
                cursor: "pointer",
                borderRadius: "4px",
                color: "#2C2C2C",
                fontSize: "15px",
                fontWeight: "bold",
              }}
              onClick={() => {
                localStorage.setItem("cookies-accepted", "true");
                window.location.reload();
              }}
            >
              X
            </button>
          </div>
        </ContainerMessage>
      </Content>
    </Container>
  );
};

export default ModalCookies;
